import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function CareerDetails4() {
return (
<>   
  <Header />

  <section className="container" style={{ paddingTop: "120px" }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        style={{
          width: "300px",
          height: "1px",
          backgroundColor: "#dcdcdc",
        }}
      ></div>

      <p
        style={{
          margin: 0,
          fontSize: "16px",
          color: "#888",
        }}
      >
        <Link
          to="/"
          style={{
            color: "#111",
            textDecoration: "none",
          }}
        >
          Home
        </Link>

        {" / "}

        <Link
          to="/careers"
          style={{
            color: "#111",
            textDecoration: "none",
          }}
        >
          Careers
        </Link>

        {" / "} Graphic Design Intern
      </p>
    </div>

    <h1
      style={{
        textAlign: "center",
        fontSize: "64px",
        lineHeight: "1.1",
        marginBottom: "80px",
      }}
    >
      <span style={{ fontWeight: "600" }}>
        Graphic Design
      </span>{" "}
      <span style={{ fontWeight: "300" }}>
        Intern
      </span>
    </h1>

    <div style={{ maxWidth: "720px", margin: "0 auto" }}>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Position:</strong> Graphic Design Intern
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Job ID:</strong> BNWJB20260157
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Employment Type:</strong> Internship (Remote)
      </p>

      <p style={{ marginBottom: "40px", fontSize: "16px" }}>
        <strong>Experience:</strong> Freshers
      </p>

      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.8",
          color: "#777",
          marginBottom: "25px",
        }}
      >
        BlackWhite Creative Services is looking for passionate and driven Graphic
        Design Interns who are eager to explore the world of visual communication
        and creative storytelling. This internship provides an excellent
        opportunity for aspiring designers to gain hands-on experience in
        fast-paced creative environments while working on branding, digital
        campaigns, and marketing collateral.
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        About the Role
      </h4>

      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.8",
          color: "#777",
          marginBottom: "40px",
        }}
      >
        As a Graphic Design Intern, you will work closely with our creative team
        to conceptualize and execute visual content across various platforms.
        Your work will include social media creatives, brand collateral,
        presentations, and digital assets. You will gain exposure to real-world
        design projects, foundation in design thinking, and the opportunity to
        strengthen your understanding of visual communication and branding.
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        Key Responsibilities
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Assist in designing creatives for social media, websites, and marketing campaigns</li>
        <li>Support branding projects including logos, brochures, and visual identity systems</li>
        <li>Work on layout design for presentations, flyers, and digital ads</li>
        <li>Collaborate with team members to brainstorm and develop creative concepts</li>
        <li>Adapt designs based on feedback and ensure brand consistency</li>
        <li>Maintain accuracy in visual language and timely delivery of design assets</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        Qualifications & Skills
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Basic to intermediate proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign)</li>
        <li>Familiarity with Figma, Adobe XD, or other UI tools is an added advantage</li>
        <li>Strong sense of typography, color, layout, and composition</li>
        <li>Creative thinking with attention to detail</li>
        <li>Ability to take feedback positively and iterate quickly</li>
        <li>Basic understanding of branding and visual communication</li>
        <li>A portfolio showcasing academic or personal design work is preferred but not mandatory</li>
        <li>Pursuing or recently completed a degree/diploma in Graphic Design, Visual Communication, or a related field</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        Internship Details
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Work Mode: Remote</li>
        <li>Duration: 6 Months</li>
        <li>Working Hours: Flexible schedule with a minimum commitment of 15–20 hours per week</li>
        <li>Availability for team meetings and feedback sessions during working days</li>
        <li>Stipend: Optional. This internship is designed as a learning-focused opportunity offering hands-on industry exposure, mentorship, and portfolio-building experience</li>
      </ul>

      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.8",
          color: "#777",
          marginBottom: "40px",
        }}
      >
        If you're someone with a curious, creative, and ready-to-build mindset,
        we'd love to have you on board.
      </p>

<hr
  style={{
    border: "none",
    borderTop: "1px solid #ddd",
    marginTop: "60px",
    marginBottom: "30px",
  }}
/>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "50px",
  }}
>
  <Link
    to="/apply-job"
    style={{
      textDecoration: "none",
      color: "#111",
      fontSize: "16px",
      fontWeight: "500",
    }}
  >
    Apply
  </Link>

  <Link
    to="/apply-job"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "22px",
    }}
  >
    →
  </Link>
</div>

    </div>
  </section>

  <Footer />
</>


);
}

export default CareerDetails4;